import React, { createContext, useContext, useState, useEffect } from "react";
import {
  getAllInvoice,
  getAllPaymentMethods,
  getAllPlans,
  getCurrentPlan,
  getNextBilling,
} from "../services/billing";

const UpgradContext = createContext();

export const UpgradProvider = ({ children }) => {
  const [data, setData] = useState({
    plans: [],
  });

  const [loading, setLoading] = useState({
    plans: true,
  });

  const [error, setError] = useState({
    plans: null,
  });

const fetchBillingData = async () => {
  try {
    // If you only need plans, no need to destructure 5 variables
    const plansRes = await getAllPlans();

    setData((prev) => ({
      ...prev,
      plans: plansRes?.data?.data || prev.plans,
    }));

    setError((prev) => ({
      ...prev,
      plans: null, // No error since fetch succeeded
    }));
  } catch (error) {
    setError((prev) => ({
      ...prev,
      plans: error?.message || "Failed to load plans",
    }));
  } finally {
    setLoading((prev) => ({
      ...prev,
      plans: false,
    }));
  }
};


  useEffect(() => {
    fetchBillingData();
  }, []);

  return (
    <UpgradContext.Provider
      value={{
        ...data,
        loading,
        error,
        refetchBilling: fetchBillingData,
      }}
    >
      {children}
    </UpgradContext.Provider>
  );
};

export const useUpgrad = () => useContext(UpgradContext);